<template>
  <div class="fileInput">
    <div v-if="defaultValue||value" :style="{backgroundImage: `url(${VUE_APP_HOST}${defaultValue})`}" @click="del"/>
    <label for="file" v-else title="點擊上傳圖片">
      <div class="uploadimage">
        <input type="file" id="file" accept="image/png, image/jpeg" @change="upload" hidden>
      </div>
    </label>
  </div>

</template>

<script>
const { VUE_APP_HOST } = process.env
export default {
  name: 'FileInput',
  props: ['defaultValue', 'folder', 'disabled'],
  data () {
    return {
      value: null,
      VUE_APP_HOST
    }
  },
  methods: {
    del () {
      if (!this.disabled) {
        this.$emit('input', null)
      }
    },
    async upload (ev) {
      if (ev.target.files[0]) {
        const image = await this.$store.dispatch('uploadFile', { event: ev, folder: this.folder })
        console.log('upload Image', this.folder, image)
        this.$emit('input', `/${this.folder}/${image.filename}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label, .fileInput {
  display: inline-block;
  width: 461px;
  height: 346px;
  background-color: #E8E8E8;
  border-radius: 10px;
  input[type=file] {
    display: none;
  }
  &>div {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
label {
  width: 461px;
  height: 346px;
}
.uploadimage {
  margin-right: auto;
  width: 461px;
  height: 346px;
  background-image: url(./upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 230px;
    top: 204px;
    transform: translateX(-50%);
  }
}
</style>
